module.exports = __webpack_public_path__ + "bcb21e21c1ebe7e4b20c334f2c4998f5.svg";